// why: imports nothing, so queryClient, datadog config and the error page can share this predicate without pulling in tldraw, the store or the router.

/**
 * The TypeError `fetch` throws when the network is gone: "Failed to fetch"
 * (Chromium), "NetworkError when attempting to fetch resource." (Firefox) or
 * "Load failed" (Safari).
 */
export const FETCH_NETWORK_ERROR_MESSAGES: ReadonlySet<string> = new Set([
  "Failed to fetch",
  "NetworkError when attempting to fetch resource.",
  "Load failed",
]);

export function isFetchNetworkError(error: unknown): boolean {
  return (
    error instanceof TypeError &&
    FETCH_NETWORK_ERROR_MESSAGES.has(error.message)
  );
}
